import { t } from '@/locale/index.js'
import { applyColumnLabels, applyOptionLabels, applySearchLabels } from '@/utils/listPageI18n.js'

const MESSAGE_COLUMNS = {
  type: 'messageAdmin.colType',
  title: 'messageAdmin.colTitle',
  content: 'messageAdmin.colContent',
  created_at: 'messageAdmin.colCreatedAt',
  operation: 'table.operation',
}

const MESSAGE_TYPE_MAP = {
  1: 'messageAdmin.typeSystem',
  2: 'messageAdmin.typeReminder',
  3: 'messageAdmin.typeAnnouncement',
}

export function applyMessageListLabels({ searchData, columns, typeOptions }) {
  applySearchLabels(searchData, {
    keywords: { labelKey: 'field.keywords' },
    type: { labelKey: 'messageAdmin.messageType' },
  })
  if (searchData?.[1]?.children?.[0]) {
    searchData[1].children[0].label = t('common.all')
  }
  applyColumnLabels(columns, MESSAGE_COLUMNS)
  applyOptionLabels(typeOptions, MESSAGE_TYPE_MAP)
}

export function applyMessageFormRules(rules) {
  if (rules.type?.[0]) rules.type[0].message = t('messageAdmin.needType')
  if (rules.title?.[0]) {
    rules.title[0].message = t('messageAdmin.needTitle')
    if (rules.title[1]) rules.title[1].message = t('messageAdmin.titleLength')
  }
  if (rules.content?.[0]) {
    rules.content[0].message = t('messageAdmin.needContent')
    if (rules.content[1]) rules.content[1].message = t('messageAdmin.contentLength')
  }
}

export { t }
